export interface WebsiteAccessContext {
  activeContextId?: string | null;
  isAgent: boolean;
  isRegionalAdmin: boolean;
  associateId?: string | null;
}

export function canAccessOwnWebsite(context: WebsiteAccessContext): boolean {
  return context.activeContextId === 'agent'
    && context.isAgent
    && !context.isRegionalAdmin
    && Boolean(context.associateId?.trim());
}